export default {
  serverURI: 'https://biomanager-homolog.certibio.com.br/api/',
  psbioURI: 'https://psbio-homolog.certibio.com.br/psbio-gateway/api/manager',
  pin: 384596,
  renewTokenURI: 'oauth/token',
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js